export function getAll() {
  return [
    {
      value: 0,
      name: "Combine",
      text: "合併",
    },
    {
      value: 1,
      name: "Separate",
      text: "分開",
    },
  ];
}
